// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"167":"aae22195","498":"05977948","645":"732660d0"}[chunkId] + ".js";
};